import { LogLevel } from './types';

export function logLevelToInt(logLevel: LogLevel) {
  switch (logLevel) {
    case 'debug':
      return 10;
    case 'info':
      return 20;
    case 'warn':
      return 30;
    case 'error':
      return 40;
    case 'fatal':
      return 50;
    default:
      return 20;
  }
}
